export interface NoResultsProps {
  message?: string;
}

const NoResults: React.FC<NoResultsProps> = ({ message = 'Nothing was found' }) => {
  return <div className="w-full py-24 text-center">{message}</div>;
};

export default NoResults;
